import React, { PropTypes, Component } from 'react';

const propTypes = {
  intl: PropTypes.object.isRequired,
  onFilterSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  filter: PropTypes.string,
};

class Filter extends Component {
  constructor(props) {
    super(props);

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      const newFilter = this.refs.input.value;
      this.props.onFilterSubmit(newFilter);
    }
  }

  handleSubmit() {
    const newFilter = this.refs.input.value;
    this.props.onFilterSubmit(newFilter);
  }

  render() {
    const search = {
      id: 'search',
      description: 'Search',
    };

    return (
      <div className={`ui fluid icon ${this.props.loading && 'loading'} input`}>
        <input
          onKeyPress={this.handleKeyPress}
          ref="input"
          type="text"
          placeholder={this.props.intl.formatMessage(search)}
          defaultValue={this.props.filter && this.props.filter}
        />
        <i onClick={this.handleSubmit} className="circular search link icon" />
      </div>
    );
  }
}

Filter.propTypes = propTypes;

export default Filter;



/** WEBPACK FOOTER **
 ** ./src/components/layout/searchBar/Filter.js
 **/